<template>
  <div class="p-2 sm:p-3">
    <div class="flex justify-center flex-wrap">
      <div class="min-w-full sm:min-w-30 max-w-5xl m-2 flex-1">
        <div class="bg-white rounded-lg shadow-card px-4 py-8 sm:p-12">
          <div class="flex flex-col md:flex-row justify-between items-center">
            <button
                :disabled="!canProceedToNextStep"
                class="btn btn-secondary font-semibold rounded-lg px-10 min-w-10 w-full md:w-auto invisible hidden md:block"
                @click="onClickCreateNew">
              + Create New Line Item
            </button>
            <h1 class="font-semibold text-2xl lg:text-3xl text-center">
              Add Line Items
            </h1>
            <button
                :disabled="!canProceedToNextStep"
                class="btn btn-secondary font-semibold rounded-lg px-10 min-w-10 w-full md:w-auto hidden md:block"
                @click="onClickCreateNew">
              + Create New Line Item
            </button>
          </div>
          <section class="text-center text-sm max-w-xl mx-auto mt-5">
            Add line items for your categories
          </section>
          <section class="flex justify-end mt-5 md:hidden">
            <button class="btn btn-secondary font-semibold rounded-lg px-10 min-w-10 w-full md:w-auto"
                    @click="onClickCreateNew">
              + Create New Line Item
            </button>
          </section>
          <vue-custom-scrollbar>
            <div class="md:border-b border-gray-300  mt-5 mb-5 md:mb-0">
              <nav class="md:inline-block md:whitespace-no-wrap select-none font-medium">
                <div v-for="category in categories" :key="category.uuid"
                     :class="category.uuid === selectedCategory.uuid ? 'active' : ''"
                     class="md:inline-block category-nav-item"
                     @click="onSelectCategory(category)">
                  <div class="cursor-pointer px-3 py-2 nav-item--title">
                    {{ category.title }}
                  </div>
                </div>
              </nav>
            </div>
          </vue-custom-scrollbar>
          <section>
            <table class="table-fixed w-full">
              <thead class="md:border-b border-gray-300">
              <tr class="text-gray-500 text-sm">
                <th class="w-64">
                  <div class="flex items-center">
                    <label
                        class="w-20 inline-flex items-center px-3 py-1 border-2 border-gray-200 md:border-none rounded-lg">
                      <input v-model="allSelected" class="form-checkbox h-6 w-6 rounded-md text-primary cursor-pointer"
                             type="checkbox">
                      <v-popover :placement="'bottom-start'" class="ml-3">
                        <button class="btn">
                          <img alt="BuildaBox Order Process" src="@/assets/icons/ic_chevron_down.svg"/>
                        </button>
                        <div slot="popover">
                          <div class="bg-white text-gray-700 py-3" role="menu">
                            <a
                                v-close-popover
                                class="block px-6 py-2 hover:bg-gray-100 hover:text-gray-900 cursor-pointer"
                                role="menuitem" @click="allSelected = true">
                              Select All
                            </a>
                            <a
                                v-close-popover
                                class="block px-6 py-2 hover:bg-gray-100 hover:text-gray-900 cursor-pointer"
                                role="menuitem" @click="allSelected = false">
                              Unselect All
                            </a>
                            <a
                                v-close-popover
                                class="block px-6 py-2 hover:bg-gray-100 hover:text-gray-900 cursor-pointer"
                                role="menuitem" @click="onClickRemoveSelected">
                              Delete Selected
                            </a>
                          </div>
                        </div>
                      </v-popover>
                    </label>
                    <div class="font-semibold text-xs text-gray-600 text-left hidden md:block">NAME</div>
                  </div>
                </th>
                <th class="hidden md:table-cell font-semibold text-xs text-gray-600 text-left">DESCRIPTION</th>
                <th class="w-24 hidden md:table-cell font-medium"></th>
              </tr>
              </thead>
              <tbody v-if="progressLoading">
              <tr>
                <td colspan="5">
                  <div class="text-center text-gray-600 my-2 p-5">
                    <Spinner class="mx-auto" orange/>
                  </div>
                </td>
              </tr>
              </tbody>
              <tbody v-else-if="lineItems.length === 0">
              <tr>
                <td colspan="5">
                  <div class="text-center text-gray-600 my-2 p-5"></div>
                </td>
              </tr>
              </tbody>
              <draggable v-else v-model="lineItems" handle=".draggable-handler" tag="tbody" @update="onUpdateSort">
                <tr v-for="(lineItem, index) in lineItems" :key="index">
                  <td class="py-5">
                    <div class="flex items-center">
                      <label class="md:w-20 inline-flex items-center px-3 py-1">
                        <input v-model="lineItem.isSelected"
                               class="form-checkbox h-6 w-6 rounded-md text-primary cursor-pointer"
                               type="checkbox">
                        <button class="btn ml-3 draggable-handler">
                          <img alt="BuildaBox Order Process" src="@/assets/icons/ic_drag.svg"/>
                        </button>
                      </label>
                      <div class="font-semibold flex-1 truncate">{{ lineItem.name }}</div>
                      <div class="md:hidden">
                        <button class="btn p-3" @click="onClickEditItem(lineItem)">
                          <img alt="BuildaBox Order Process" src="@/assets/icons/edit-pencil.svg"/>
                        </button>
                        <button class="btn p-3 ml-2" @click="onClickRemoveItem(lineItem)">
                          <img alt="BuildaBox Order Process" src="@/assets/icons/ic_remove.svg"/>
                        </button>
                      </div>
                    </div>
                    <div class="md:hidden font-normal text-gray-600 ml-12 mr-5">
                      <div class="mt-2">{{ lineItem.description }}</div>
                    </div>
                  </td>
                  <td class="py-5 hidden md:table-cell font-normal text-gray-600 text-left">
                    {{ lineItem.description }}
                  </td>
                  <td class="py-5 hidden md:table-cell">
                    <button class="btn p-3" @click="onClickEditItem(lineItem)">
                      <img alt="BuildaBox Order Process" src="@/assets/icons/edit-pencil.svg"/>
                    </button>
                    <button class="btn p-3 ml-2" @click="onClickRemoveItem(lineItem)">
                      <img alt="BuildaBox Order Process" src="@/assets/icons/ic_remove.svg"/>
                    </button>
                  </td>
                </tr>
              </draggable>
            </table>
          </section>
          <section class="mt-16">
            <div class="flex flex-col-reverse sm:flex-row justify-between">
              <button
                  class="btn btn-secondary font-semibold rounded-lg px-10 min-w-10 mt-5 sm:mt-0"
                  @click="$emit('back')"
              >
                <span>Back</span>
              </button>
              <div>
                <button
                    v-if="order.from === 'buildabox'"
                    class="btn btn-secondary font-semibold rounded-lg px-10 min-w-10 mr-3"
                    @click="$emit('submit')"
                >
                  <span>Skip</span>
                </button>
                <button
                    :disabled="!canProceedToNextStep"
                    class="btn btn-primary font-semibold rounded-lg px-10 min-w-10"
                    @click="$emit('submit')"
                >
                  <span v-if="!progressSaving">Next</span>
                  <Spinner v-if="progressSaving" class="mx-auto"/>
                </button>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
    <Modal v-if="showModal">
      <div slot="modal-wrapper">
        <div class="flex justify-center p-2">
          <div class="bg-white rounded-lg shadow-card px-4 py-8 sm:p-12 min-w-full sm:min-w-30 max-w-3xl">
            <OrderLineItemEditor
                :categories="categories"
                :line-item="selectedItem"
                :order="order"
                @cancel="showModal = false"
                @submit="showModal = false; loadCategories()"
            />
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import Modal from '@/components/common/Modal'
import Spinner from '@/components/common/Spinner'
import draggable from 'vuedraggable'
import Api from '@/api/api_v1.0'
import OrderLineItemEditor from '@/components/OrderLineItemEditor'
import vueCustomScrollbar from 'vue-custom-scrollbar'

export default {
  components: { OrderLineItemEditor, Spinner, Modal, draggable, vueCustomScrollbar },
  data () {
    return {
      categories      : [],
      selectedCategory: '',
      lineItems       : [],
      selectedItem    : '',
      showModal       : false,
      progressLoading : false,
      progressSaving  : false
    }
  },
  computed: {
    order () {
      return this.$store.state.currentEditingOrder
    },
    allSelected: {
      get () {
        if (this.lineItems.length > 0) {
          return this.lineItems.findIndex(item => !item.isSelected) === -1
        } else {
          return false
        }
      },
      set (value) {
        this.lineItems.every(item => {
          item.isSelected = value
          return true
        })
      }
    },
    canProceedToNextStep () {
      return this.categories.length !== 0
    },
  },
  mounted () {
    this.loadCategories()
  },
  methods: {
    loadCategories () {
      this.progressLoading = true
      Api.getCategoriesForOrder(this.order.uuid).then(categories => {
        this.progressLoading = false
        this.categories = categories
        if (this.selectedCategory) {
          this.onSelectCategory(this.categories.find(category => category.uuid === this.selectedCategory.uuid))
        } else {
          this.onSelectCategory(this.categories[0])
        }
      }).catch(() => {
        this.progressLoading = false
      })
    },
    onSelectCategory (category) {
      this.selectedCategory = category
      this.lineItems = category.items
    },
    onClickCreateNew () {
      const position = this.lineItems.length + 1
      this.selectedItem = {
        category_uuid: this.selectedCategory.uuid,
        uuid         : '',
        name         : '',
        description  : '',
        price        : '',
        image        : '',
        file         : '',
        position     : position
      }
      this.showModal = true
    },
    onClickEditItem (lineItem) {
      this.selectedItem = JSON.parse(JSON.stringify(lineItem))
      this.showModal = true
    },
    onClickRemoveItem (lineItem) {
      this.$swal({
        title            : 'Remove Line Item',
        text             : `Are you sure to remove the item - ${lineItem.name}?`,
        confirmButtonText: 'Yes',
        cancelButtonText : 'No',
        showCancelButton : true
      }).then((result) => {
        if (result.isConfirmed) {
          lineItem.isSelected = true
          this.removeSelectedItems()
        }
      })
    },
    onClickRemoveSelected () {
      if (this.lineItems.findIndex(category => category.isSelected) !== -1) {
        this.$swal({
          title            : 'Remove Line Items',
          text             : `Are you sure to remove the selected items?`,
          confirmButtonText: 'Yes',
          cancelButtonText : 'No',
          showCancelButton : true
        }).then((result) => {
          if (result.isConfirmed) {
            this.removeSelectedItems()
          }
        })
      }
    },
    onUpdateSort () {
      const ids = this.lineItems.map(item => item.uuid)
      Api.sortLineItemsForOrder(this.order.uuid, this.selectedCategory.uuid, ids)
    },
    async removeSelectedItems () {
      const ids = this.lineItems.filter(item => item.isSelected).map(item => item.uuid)
      this.progressLoading = true
      Api.deleteLineItemsFromOrder(this.order.uuid, this.selectedCategory.uuid, ids).then(() => {
        this.progressLoading = true
        this.loadCategories()
      }).catch(() => {
        this.progressLoading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.category-nav-item {
  @apply border-l-2;
  @apply border-white;

  .nav-item--title {
    @apply border-b-2;
    @apply border-gray-300;
    @apply text-gray-600;
  }

  &.active {
    @apply border-primary;

    .nav-item--title {
      @apply text-primary;
    }
  }

  @screen md {
    .nav-item--title {
      @apply border-white;
    }

    &.active {
      @apply border-white;

      .nav-item--title {
        @apply border-primary;
      }
    }
  }
}
</style>